export const CHAR_PRESETS: Record<string, string> = {
  "Classic ramp": "MWB@#%&8N0$Hho*+=xc~-:., ",
  "Heavy & light": "MWN@#H+:. ",
  "Letters only": "MWNHBQOoxc:il. ",
  Punctuation: "@#%&*+=~^-:;,.'`\" ",
  Digits: "8906453217. ",
  Vowels: "OoAaEeIiUu. ",
  Symbols: "-.:=+%#* ",
  Symbols2: "!@#$%^&*()))_+~ ",
  Binary: "10 ",
  "Morse-ish": "—–-·. ",
  "Static / noise": "·.,;:`'\" ",
  "Math symbols": "∑∏∫∆∇∂∞∩∪⊂⊃∈· ",
  "Greek glyphs": "ΩΨΦΞΠΣΛΘΔΓμπ· ",
  "Runes (futhark)": "ᚠᚢᚦᚨᚱᚲᚷᚹᚺᚾᛁ· ",
  Currency: "€£¥₩₪₹$¢. ",
  "Winter Emoji": "❄️🌨️⛄🏔️🧊🌬️❄️⛷️🀩 ",
  "Color Emoji": "❤️💙💚🖤💛💜🧡🤍🩵🩶",
  "Block halftone": "█▓▒░ ",
  "Bar ramp": "█▇▆▅▄▃▂▁ ",
  "Braille blocks": "⣿⣷⣯⣟⡿⢿⣻⣽ ",
  "Box double": "╬╪╫╠╣╦╩╔╗╚╝║═ ",
  "Box single": "┼┤├┬┴┐└│─ ",
  Diagonals: "╱╲╳ ",
  "Arrows filled": "➤➣➢➡⬆⬇⬅ ",
  "Arrows standard": "↑↗→↘↓↙←↖↕↔↩↪ ",
  "Arrows long": "⟶⟵⟷⟹⟸⟺ ",
  "Arrows two-headed": "↠↞↟↡ ",
  "Corner triangles": "◤◥◢◣ ",
  "Card suits": "♠♣♥♦· ",
  Sparkles: "✦✧✶✷✸✹✺✻✼ ",
};
